import { Routes } from '@angular/router';

import { AdminDashboardComponent } from '../../admindashboard/admindashboard.component';
import { AddNewClientComponent } from '../../addnewclient/addnewclient.component';
import { AddDocumentComponent } from '../../adddocument/adddocument.component';
import { AddDepartmentComponent } from 'app/add-department/add-department.component';
import { PackagesComponent } from 'app/packages/packages.component';
import {AddModuleComponent} from 'app/add-module/add-module.component';
import { AddItemTypeComponent } from 'app/Add-ItemType/Add-ItemType.component';


export const AdminLayoutRoutes: Routes = [

    { path: 'admindashboard',      component: AdminDashboardComponent },
    { path: 'addnewclient',   component: AddNewClientComponent },
    { path: 'adddocument',     component: AddDocumentComponent },
    { path: 'Adddepartment',     component: AddDepartmentComponent },
    { path: 'addpackage',     component: PackagesComponent },
    { path: 'additemtype', component: AddItemTypeComponent },



    
];
